import React, { useState, useEffect } from "react";
import { Form, Button, Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { getDepartmentList } from "../infrastructure/apiService";
import { getHospitalList } from "../infrastructure/apiService";
import { getHospitalDepartmentReport } from "../infrastructure/apiService";
import * as XLSX from "xlsx";

const ProcessingReport = () => {
  const [hospitals, setHospitals] = useState([]);

  const [selectedHospital, setselectedHospital] = useState(0);
  const [selectedDepartment, setselectedDepartment] = useState("");
  const [departments, setDepartments] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  //const api = useApi();

  const handleGenerateReport = async () => {
    debugger;
    const response = await getHospitalDepartmentReport(
      selectedHospital,
      selectedDepartment,
      fromDate,
      toDate
    );
    if (response !== null && response.length > 0) {
      exportToExcel(response);
    }
  };

  const getDepartments = async (hospitalId) => {
    debugger;
    const response = await getDepartmentList(hospitalId);
    setDepartments(response);
  };

  const exportToExcel = (data) => {
    // Create a worksheet from the data
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate a file and download it
    XLSX.writeFile(workbook, "Report_HospitalId_" + selectedHospital + ".xlsx");
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getHospitalList();
        setHospitals(response);
      } catch (error) {
      } finally {
      }
    };

    fetchData();
  }, []);

  return (
    <Container>
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <h2>Download Report</h2>
            </div>
            <div className="card-body">
              <Form>
                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <Form.Group controlId="hospital">
                        <Form.Label>Hospital</Form.Label>
                        <Form.Select
                          value={selectedHospital}
                          onChange={(e) => {
                            debugger;
                            setselectedHospital(e.target.value);
                            getDepartments(e.target.value);
                          }}
                        >
                          {hospitals.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.name}
                            </option>
                          ))}
                          {/* Add more options as needed */}
                        </Form.Select>
                      </Form.Group>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <Form.Group controlId="department">
                        <Form.Label>Department</Form.Label>
                        <Form.Select
                          value={selectedDepartment}
                          onChange={(e) =>
                            setselectedDepartment(e.target.value)
                          }
                        >
                          {departments.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.name}
                            </option>
                          ))}
                          {/* Add more options as needed */}
                        </Form.Select>
                      </Form.Group>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <Form.Group controlId="fromDate">
                        <Form.Label>Processed From Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                        />
                      </Form.Group>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <Form.Group controlId="toDate">
                        <Form.Label>Processed To Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <Button
                      variant="primary"
                      onClick={handleGenerateReport}
                      disabled={
                        !selectedHospital ||
                        !selectedDepartment ||
                        !fromDate ||
                        !toDate
                      }
                    >
                      Generate
                    </Button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ProcessingReport;
